"use strict";

require("core-js/modules/es6.object.assign");

var _slicedToArray = require("/mnt/ephemeral/jenkins/workspace/chart-gatsby/corporate/node_modules/gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FloatingStatus = void 0;

var react_1 = __importStar(require("react"));

var styled_1 = __importDefault(require("../../../../theme/styled"));

var styled_system_1 = require("styled-system");

var field_context_1 = __importDefault(require("./field-context"));

var FloatingStatus;

(function (FloatingStatus) {
  FloatingStatus["Default"] = "default";
  FloatingStatus["Floating"] = "floating";
})(FloatingStatus = exports.FloatingStatus || (exports.FloatingStatus = {}));

var Wrapper = styled_1["default"].div({
  position: 'relative'
});

var FieldBase = function FieldBase(_a) {
  var children = _a.children,
      disabled = _a.disabled,
      _a$floating = _a.floating,
      enableFloating = _a$floating === void 0 ? false : _a$floating,
      rest = __rest(_a, ["children", "disabled", "floating"]);

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isFloating = _react_1$useState2[0],
      _setIsFloating = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(false),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      hasError = _react_1$useState4[0],
      _setHasError = _react_1$useState4[1];

  var _react_1$useState5 = react_1.useState(false),
      _react_1$useState6 = _slicedToArray(_react_1$useState5, 2),
      hasFocus = _react_1$useState6[0],
      _setHasFocus = _react_1$useState6[1];

  var context = {
    disabled: disabled,
    enableFloating: enableFloating,
    hasError: hasError,
    hasFocus: hasFocus,
    isFloating: isFloating,
    setIsFloating: function setIsFloating(value) {
      return _setIsFloating(value);
    },
    setHasError: function setHasError(value) {
      return _setHasError(value);
    },
    setHasFocus: function setHasFocus(value) {
      return _setHasFocus(value);
    }
  };
  return react_1["default"].createElement(field_context_1["default"].Provider, {
    value: context
  }, react_1["default"].createElement(Wrapper, Object.assign({}, rest, {
    enableFloating: enableFloating
  }), children));
};

var Field = styled_1["default"](FieldBase)(styled_system_1.space);
exports["default"] = Field;